<template>
    <footer class="store-footer p-sm-3 text-light bg-dark1 bg-site">
        <div class="container py-2 py-sm-3">
            <div class="row d-flex align-items-center">
                <div class="col-sm-3 mb-2 mb-sm-0">
                    <a href="/"><img :src="G.systemData?.footer_logo?.value" :alt="G.projectName" style="width: 250px;" class="rounded" /></a>
                    <!-- <a href="/"><img src="/assets/images/logo-tw.png" :alt="G.projectName" style="width: 250px;" class="rounded" /></a> -->
                    <!-- <h5 class="h3">{{G.projectName}}</h5> -->
                </div>
                <div class="col-sm-9">
                    <p class="fs-6">{{TR.slogan_text}}</p>
                </div>
            </div>

            <div class="row row-cols-1 row-cols-sm-2 mt-sm-4 pt-3 border-1 border-top small">
                <div class="col">
                    <p v-html="G.footerPowered"></p>
                </div>
                <div class="col d-flex">
                    <ul class="list-unstyled d-flex ms-auto">
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-google"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-youtube"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-twitter"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-instagram"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-facebook-f"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-whatsapp"></i></a></li>
                    </ul>
                </div>
            </div>

        </div>
    </footer>
</template>


<script>
import { ref, watchEffect } from 'vue';

import { useStore } from "@/system_modules/store";

import { G } from '@/_common';

export default {
    name: 'FooterC',
    props:{
        data:{
            type: Array,
            default: () => []
        },
    },
    setup() {
        const store = useStore();
        const TR = ref({});

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        return { G, TR };
    },
}
</script>

<style lang="scss">
.store-footer {
    a{
        color: #c9c9c9;
    }
    a:hover{
        color: rgb(128, 128, 128);
    }
    .social-links > a{
        display: flex;
        // padding: 8px;
        margin: 10px;
        width: 60px;
        height: 60px;
        background-color: #443f3f;
        border-radius: 50%;
        // font-size: 18pt;
        font-size: calc(var(--bs-body-font-size) * 1.2);
        justify-content: center;
        align-items: center;
        // color: black;
    }
    .social-links > a:hover{
        background-color: #b3b3b3;
    }
}
</style>
